// Dynamic Page Hero Images
export default function subpageHero() {
  const heroContentModule = $('.dynamicPageContainer .rowIndex-1 .TextMediaModule');
  const heroImage = heroContentModule.find('.largeImage');
  const isFairgrounds = $('body').hasClass('fairgrounds-homepage');

  if (heroImage.length > 0 && !isFairgrounds) {
    $('body').addClass('has-hero');
    const heroImageSrc = getSrc(heroImage);
    const heroImagePath = heroImageSrc.replace(/([()\\|?])/g, '\\$1');
    const heroTitleText = heroContentModule.find('.moduleTitle').text();
    const heroDescText = heroContentModule.find('.previewArea').text();
    const heroHTML = `
    <div class="subpage-hero" style="background-image: url(${heroImagePath})">
      <div>
        <div class="subpage-hero_content">
          <h1>${heroTitleText}</h1>
          <p>${heroDescText}</p>
        </div>
      </div>
    </div>
  `;

    $(heroHTML).insertBefore('.content');

    if (heroTitleText !== '') {
      $('.subpage-hero_content').append('<h2>' + heroTitleText + '</h2>');
    }
    if (heroDescText !== '') {
      $('.subpage-hero_content').append('<p>' + heroDescText + '</p>');
    }

    $('.dynamicPageContainer .rowIndex-1').hide();

    heroMarginTop();
  }

  $('.header').prepend($('.generalmessage'));
}

function getSrc(el) {
  return el.attr('src') ? el.attr('src') : el.attr('data-src');
}

// Calculate Subpage Hero margin top
function heroMarginTop() {
  const interval = setInterval(function () {
    if ($('body').hasClass('pageIsLoaded')) {
      const headerHeight = $('header').outerHeight();
      $('.subpage-hero').css('margin-top', headerHeight + 'px');

      clearInterval(interval);
    }
  }, 300);
}
